export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const API_TIMEOUT_MS = 20000
export const REQUEST_TIMEOUT_MESSAGE = 'Request Timeout!'
